import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { AiFillHome } from "react-icons/ai";
import { BsTelegram, BsFacebook, BsYoutube } from "react-icons/bs";

import { Slider } from "./../Home/slider";
import mtov from "./../../Images/mtov.jpg";
import iiit_Allahabad from "./../../Images/iiit_Allahbad.jpg";
import kent_State from "./../../Images/kent_State.jpg";
import mdpi from "./../../Images/mdpi.jpg";
import springer_blockchain from "./../../Images/springer_blockchain.jpg";
import springer from "./../../Images/springer.jpg";
import iiit_Allahabad_Slip from "./../../Images/iiit_Allahbad_Slip.jpg";
import reblockchain_Group from "./../../Images/reblockchain_Group.jpg";
import korean_logo from "./../../Images/korean_logo.jpg";
import dept_Of_Electronics from "./../../Images/dept_Of_Electronics.jpg";
import advanced_Telerobotics from "./../../Images/advanced_Telerobotics.jpg";
import ministry_For_Development from "./../../Images/ministry_For_Development.jpg";
import CCC from "./../../Images/CCC.jpg";
import Coikism_Research from "./../../Images/Coikism_Research.jpg";
import KICSP from "./../../Images/KICSP.jpg";
import libelium from "./../../Images/libelium.jpg";
import Coikosity from "./../../Images/Coikosity.jpg";
import ieee_pune from "./../../Images/ieee_pune.jpg";
import VESTELLALAB from "./../../Images/VESTELLALAB.jpg";

export const Footer = () => {
  const images = [
    mtov,
    iiit_Allahabad,
    kent_State,
    mdpi,
    springer_blockchain,
    springer,
    iiit_Allahabad_Slip,
    reblockchain_Group,
    korean_logo,
    dept_Of_Electronics,
    advanced_Telerobotics,
    ministry_For_Development,
    CCC,
    Coikism_Research,
    KICSP,
    libelium,
    Coikosity,
    ieee_pune,
    VESTELLALAB,
  ];
  return (
    <footer className="footer">
      <div className="heading heading-footer">
        <h1>Organized by</h1>
      </div>
      <Slider Images={images} time={1000} count={6} heigth={"200px"} />
      <div className="footer-box">
        <div className="heading">
          <h1 style={{ color: "#d9d6d6" }}>CONTACT US</h1>
        </div>
        <div className="container-footer">
          <div className="footer-column">
            <h4>Local Contact Person</h4>
            <h6>Prof. Wan Young Chung</h6>
            <h6>Phone: 051-629-6223</h6>
            {/* <h6>Office: +99 (871) 238-65-19</h6> */}
            {/* <h6>
              Telegram: <Link className="footer-column-Link">@Sarvartuit</Link>
            </h6> */}
            <h6>
              Email:{" "}
              <Link
                className="footer-column-Link"
                to="mailto:wychung@pknu.ac.kr"
              >
                wychung@pknu.ac.kr
              </Link>
            </h6>
          </div>
          <div className="footer-column">
            <h4>Local Venue Contact Details</h4>
            <h6>
            EXCO (Daegu Exhibition & Convention Center),
            Daegu, Korea
            </h6>
            <h6>Phone : +82-53-601-5000</h6>
            <h6>
              Venue:{" "}
              <Link
                className="footer-column-Link"
                to="https://www.google.com/maps/place/10+Exco-ro,+Buk-gu,+Daegu,+South+Korea/@35.9070195,128.6105367,17z/data=!3m1!4b1!4m6!3m5!1s0x3565e1a987bcbe27:0xe15aaedb473fd952!8m2!3d35.9070152!4d128.6131116!16s%2Fg%2F11jz7p9z7f?entry=ttu"
              >
                10 EXCO-RO, BUK-GU, DAEGU 41515, KOREA
              </Link>
            </h6>
          </div>
          <div className="footer-column">
            <h4>Organizing Chair of IHCI Society</h4>
            <h6>Dr. Dhananjay Singh</h6>
            <h6>Phone: +82-10-5844-9415</h6>
            <h6>Office: +82-31-330-4731</h6>
            <h6>
              Email:{" "}
              <Link
                className="footer-column-Link"
                to="mailto:dsingh@hufs.ac.kr"
              >
                dsingh@hufs.ac.kr
              </Link>
            </h6>
          </div>
        </div>
        <div className="footer-link-box">
          <Link to="/">
            <AiFillHome className="footer-link" />
          </Link>
          <Link to="https://t.me/+a3g1XOK2Pe1lMmU1">
            <BsTelegram className="footer-link" />
          </Link>
          <Link to="https://www.facebook.com/IHCI2020/?ref=page_internal">
            <BsFacebook className="footer-link" />
          </Link>
          <Link to="https://www.youtube.com/channel/UCW1rb1Xn25FwyoJOjAfUpFw">
            <BsYoutube className="footer-link" />
          </Link>
        </div>
      </div>
    </footer>
  );
};
